import { cn } from "@/shared/lib/cn";

export interface ShopHeroGridProps {
  className?: string;
}

/**
 * La retícula: una cuadrícula de 72 px en blanco al 5 %.
 *
 * Da al fondo una referencia de profundidad —el vídeo es una forma
 * orgánica flotando en negro, sin horizonte ni escala— y es lo que se
 * desplaza de forma más evidente con el parallax, porque una línea recta
 * moviéndose se nota y una nube difusa no.
 *
 * ── La máscara evita que parezca papel milimetrado ───────────────────
 * Sin ella, la cuadrícula llega hasta el borde inferior con la misma
 * fuerza y la portada se lee como una hoja cuadriculada. Con el degradado
 * radial se desvanece hacia abajo y hacia los lados: queda como textura,
 * que es lo que es.
 *
 * ── Cuánto pesa en el contraste ──────────────────────────────────────
 * 5 % de blanco es lo más claro que esta capa puede aportar, y ese es
 * exactamente el valor con el que se dimensionó el velo. Subirlo obliga a
 * rehacer la medición.
 */
export function ShopHeroGrid({ className }: ShopHeroGridProps) {
  return (
    <div
      className={cn(
        "absolute inset-0",
        "bg-[linear-gradient(to_right,rgba(255,255,255,0.05)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.05)_1px,transparent_1px)]",
        "bg-[length:72px_72px]",
        "[mask-image:radial-gradient(130%_100%_at_50%_0%,black_0%,rgba(0,0,0,0.35)_55%,transparent_85%)]",
        className,
      )}
    />
  );
}
